import { Toaster } from "sonner";
import background from "@/assets/images/background.svg";
import { RecoverPassword } from "@/components/RecoverPassword";

export const RequestPage = () => {
  return (
    <div
      className="w-screen h-screen bg-cover bg-center bg-no-repeat flex justify-start"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="bg-[#14452C] h-full w-full lg:w-1/2 flex justify-center items-center">
        <RecoverPassword />
        <Toaster position="bottom-right" richColors />
      </div>
    </div>
  );
};
